import { cnTwMerge } from "@vega-core/utils/cnTwMerge";

export type CoInvestmentMetricProps = {
  title: string;
  value: React.ReactNode | string;
  isActive?: boolean;
  isLoading?: boolean;
};

export const CoInvestmentMetric = ({
  title,
  value,
  isActive,
}: Omit<CoInvestmentMetricProps, "isLoading">) => (
  <div className="flex flex-row justify-between sm:flex-col 2xl:text-right gap-1 py-2 px-2 sm:px-4 l:px-l-4 2xl:px-l-8">
    <p
      className="body-base-regular sm:body-small-regular text-text/secondary truncate"
      title={title}
    >
      {title}
    </p>
    <p
      className={cnTwMerge("body-base-medium sm:body-semi-large-medium", {
        "text-text/interactive": isActive,
      })}
    >
      {value}
    </p>
  </div>
);
